import { Alert } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const LimiteCreditoPJ = ({ data }) => {
  return (
    <>
      <TitleStripe>Limite de crédito</TitleStripe>
      {!data?.ErrorMessage ? (
        <>
          {" "}
          <div className="grid grid-cols-3 gap-4">
            <div className="flex flex-col items-center justify-center text-center gap-2 shadow-md rounded-md p-4 border border-gray-200">
              <div className="font-semibold text-lg">Perfil Arriscado</div>
              <div>
                <div>Valor limite:</div>
                <div className="font-semibold text-lg text-orange-400">
                  {data?.CreditLimitP1}
                </div>
              </div>
              <div className="mt-2">
                <div>Capacidade de Pagamento:</div>
                <div className="font-semibold text-lg text-orange-400">
                  {data?.PaymentCapabilityPercentageP1}
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center text-center gap-2 shadow-md rounded-md p-4 border border-gray-200">
              <div className="font-semibold text-lg">Perfil Moderado</div>
              <div>
                <div>Valor limite:</div>
                <div className="font-semibold text-lg text-blue-500">
                  {data?.CreditLimitP2}
                </div>
              </div>
              <div className="mt-2">
                <div>Capacidade de Pagamento:</div>
                <div className="font-semibold text-lg text-blue-500">
                  {data?.PaymentCapabilityPercentageP2}
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center text-center gap-2 shadow-md rounded-md p-4 border border-gray-200">
              <div className="font-semibold text-lg">Perfil Conservador</div>
              <div>
                <div>Valor limite:</div>
                <div className="font-semibold text-lg text-green-500">
                  {data?.CreditLimitP3}
                </div>
              </div>
              <div className="mt-2">
                <div>Capacidade de Pagamento:</div>
                <div className="font-semibold text-lg text-green-500">
                  {data?.PaymentCapabilityPercentageP3}
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </>
      ) : (
        <Alert className="mt-1" withBorderAccent>
          {data?.ErrorMessage}
        </Alert>
      )}
    </>
  );
};

export default LimiteCreditoPJ;
